// This function gets called at build time on server-side.
// It may be called again, on a serverless function, if
import { getStoryBySlug } from "@cinch-nx/data-storyblok";
export const getStaticPropsGenerator = (path)=>{
    return async ({ params , preview =false  })=>{
        try {
            var ref;
            const slug = params ? params === null || params === void 0 ? void 0 : params["slug"] : "index";
            const story = await getStoryBySlug(`${path}/${slug}`, {
                version: preview ? "draft" : "published",
                cv: Date.now()
            });
            if (!story) {
                throw new Error("Seo page failed to get story");
            }
            const HeroProps = (ref = story.content) === null || ref === void 0 ? void 0 : ref.hero[0];
            return {
                props: {
                    story,
                    preview,
                    layoutProps: {
                        heroProps: HeroProps,
                        showBorderRadius: true,
                        showFooterBorderRadius: false
                    }
                },
                revalidate: 60
            };
        } catch (error) {
            console.log(error);
            return {
                notFound: true,
                props: {
                    story: null,
                    preview,
                    layoutProps: {
                        heroProps: {},
                        showBorderRadius: true,
                        showFooterBorderRadius: false
                    }
                },
                revalidate: 60
            };
        }
    };
};
